export const baseUrl = "https://pyeaukiwxc.us-west-2.awsapprunner.com";

export const apiPaths = {
  // get_pending_users: "/get_users_data",
  get_all_users: "/get_users_data",
  update_user_status: "/approve_user",
  delete_user: "/delete_user",
};
